import { render, staticRenderFns } from "./FreeForm.vue?vue&type=template&id=cbdddb54&scoped=true&"
import script from "./FreeForm.vue?vue&type=script&lang=js&"
export * from "./FreeForm.vue?vue&type=script&lang=js&"
import style0 from "./FreeForm.vue?vue&type=style&index=0&id=cbdddb54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdddb54",
  null
  
)

export default component.exports